var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C4.93 22 0 17.07 0 11C0 4.93 4.93 0 11 0C17.07 0 22 4.93 22 11C22 17.07 17.07 22 11 22ZM11 2C6.04 2 2 6.04 2 11C2 15.96 6.04 20 11 20C15.96 20 20 15.96 20 11C20 6.04 15.96 2 11 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.79 13.45H10.09C10.09 13.2 10.09 13.05 10.09 13C10.09 12.44 10.18 11.98 10.36 11.62C10.54 11.26 10.91 10.85 11.45 10.4C11.99 9.95 12.32 9.66 12.43 9.52C12.59 9.3 12.68 9.06 12.68 8.79C12.68 8.42 12.53 8.1 12.24 7.84C11.95 7.58 11.56 7.44 11.07 7.44C10.58 7.44 10.2 7.58 9.88 7.85C9.56 8.12 9.34 8.54 9.22 9.11L7.5 8.89C7.55 8.08 7.89 7.4 8.51 6.84C9.13 6.28 9.96 6 10.98 6C12.05 6 12.91 6.28 13.54 6.85C14.17 7.42 14.49 8.08 14.49 8.84C14.49 9.26 14.37 9.65 14.14 10.03C13.91 10.41 13.41 10.91 12.65 11.56C12.26 11.89 12.01 12.16 11.91 12.36C11.81 12.56 11.77 12.92 11.78 13.45H11.79ZM10.09 16V14.1H11.96V16H10.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.cbe2b883fdbc9224ffa15ae1b115a1e7.svg";
export { ForwardRef as ReactComponent };